import { IsNotEmpty, IsNumber, Min } from 'class-validator';

/**
 * Model that represents a physical dimentions of a package that contains Return/Warranty items.
 */
export class PackageDimensions {
  /**
   * Height of the parcel/pellet.
   */
  @IsNumber()
  @Min(0)
  public height: number;

  /**
   * Width of the parcel/pellet.
   */
  @IsNumber()
  @Min(0)
  public width: number;

  /**
   * Length of the parcel/pellet.
   */
  @IsNumber()
  @Min(0)
  public length: number;

  /**
   * Unit of the aforementioned dimentions
   * Ex: 'in' or 'cm'
   */
  @IsNotEmpty()
  public unit: string;
}
